import { DateTimePickerCSSStyle } from "./datetimepickercss";
import * as React from "react";
import DatePicker from "react-datepicker";

// import "react-datepicker/dist/react-datepicker.css";
import './datetimepicker.css';

export interface DateTimePickerItemProps
{
    label: string;
    hint: string;
    contentType: string;
    value: Date;
    isRequired: boolean;
    style:DateTimePickerCSSStyle;
    disabled:boolean;
    autocomplete:string;
    errorMessage?:string;
    onChange?(value:any):void;
    onKeyPress?(e:React.KeyboardEvent):void;
    
}

export interface DateTimePickerItemState{
    value: Date;
}

export class DateTimePickerItem extends React.Component<DateTimePickerItemProps, DateTimePickerItemState>{
    
    
    
    onChange:Function = ()=>{};
    constructor(props: DateTimePickerItemProps){
        super(props);
        
        this.state = {value:this.props.value};
        
        if(this.props.onChange !== undefined){
            this.onChange = this.props.onChange;
        }
        this.onType = this.onType.bind(this);
    }

    
    render(){

        // return(
        //         <div style={this.props.style.getWrapperCSSStyle()}>
        //             {this.props.label && <div style={this.props.style.getLabelCSSStyle()}>{this.props.label}</div>}
        //             <div style={this.props.style.getInputWrapperCSSStyle(this.props.isRequired, this.props.disabled)}>
        //             {/* <DatePicker  selected={this.state.value} onChange={this.onType}  showTimeSelect={true} timeFormat="HH:mm" timeIntervals={1} dateFormat="DD/MM/yyyy HH:mm" calendarClassName="red-border"/> */}
        //             <DatePicker  selected={this.state.value} onChange={this.onType} locale="pt-BR" showTimeSelect={true} timeFormat="p" timeIntervals={1} dateFormat="Pp" calendarClassName="red-border"/>
        //             </div>
        //             {this.props.errorMessage!==undefined && 
        //                 <div style={this.props.style.getErrorMsgCSSStyle()}>
        //                     {this.props.errorMessage}
        //                 </div>}
        //         </div>);

    
        return (
        <div style={{}}>
        
            {/* <div style={this.props.style.getInputWrapperCSSStyle(this.props.isRequired, this.props.disabled)}> */}
                    <DatePicker selected={this.state.value} onChange={(date:any)=>this.onType(date)}  showTimeSelect={true} timeFormat="HH:mm" timeIntervals={1} timeCaption="time" dateFormat="dd/MM/yyyy HH:mm"/>

            {/* </div> */}
            {this.props.errorMessage!==undefined && 
                <div style={this.props.style.getErrorMsgCSSStyle()}>
                             {this.props.errorMessage}
                </div>}

        </div>
        );
        
        
    }

    UNSAFE_componentWillReceiveProps(nextProps:DateTimePickerItemProps){
        if(nextProps.onChange !== undefined){
            this.onChange = nextProps.onChange;
        }
        if(this.state.value !== nextProps.value){
            this.setState({value:nextProps.value});
        }
    }

    onType(value: any): void {
        this.setState({value:value});
        this.onChange(value);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/datetimepicker/datetimepickeritem.tsx